import { useState, useEffect, useRef } from "react";

const useActiveFeature = (selectedFeatures) => {
    const [activeFeatureId, setActiveFeatureId] = useState(selectedFeatures.length > 0 ? selectedFeatures[selectedFeatures.length - 1].properties.id : null);
    const prevSelectedFeaturesRef = useRef(selectedFeatures);

    // Handle the case a new feature is added or removed.
    useEffect(() => {
        if (selectedFeatures !== prevSelectedFeaturesRef.current) {
            if (selectedFeatures && selectedFeatures.length > 0) {
                // When selection changes (from map or by removing a feature), 
                // we default to the last one in the list (usually the last clicked)
                setActiveFeatureId(selectedFeatures[selectedFeatures.length - 1].properties.id);
            } else {
                setActiveFeatureId(null);
            }
            prevSelectedFeaturesRef.current = selectedFeatures;
        }
    }, [selectedFeatures]);

    // Handle the case where the active feature was removed from selection but the array reference didn't change (unlikely with immutable patterns but safe)
    useEffect(() => {
        if (activeFeatureId && selectedFeatures && selectedFeatures.length > 0) {
            const stillSelected = selectedFeatures.some(f => f.properties.id === activeFeatureId);
            if (!stillSelected) {
                setActiveFeatureId(selectedFeatures[selectedFeatures.length - 1].properties.id);
            }
        }
    }, [selectedFeatures, activeFeatureId]);

    const activeFeature = selectedFeatures?.find(f => f.properties.id === activeFeatureId) || null;

    return {
        activeFeatureId,
        setActiveFeatureId,
        activeFeature
    };
};

export default useActiveFeature;
